<section class="market-admin-dashboard" aria-label="Welcome and quick actions">
    <div class="welcome">
        <h1>Welcome</h1>
        <div class="user-name"[title]="userName">{{userName}}</div>
        <p>
            Administer users, permissions, and platform settings. Use the quick actions below to jump into common tasks.
        </p>

        <div class="meta" role="list">
            <span class="pill" role="listitem"><mat-icon class="pill-icon">badge</mat-icon>Role: {{ roleGreeting || 'Admin' }}</span>

            @if (userRole !== 'System Admin') {
                <span class="pill" role="listitem"><mat-icon class="pill-icon">public</mat-icon>Market: {{ userMarket }}</span>
            }

            @if (userBusinessUnits) {
                <span class="pill" role="listitem"><mat-icon class="pill-icon">business</mat-icon>Business Unit: {{ userBusinessUnits }}</span>
            }
        </div>

        <div class="grid">

            @if (canManageCycles) {
                <a class="card" role="button" aria-label="Create new cycle" [routerLink]="['/create-cycle', userMarketId || 0]">
                    <div>
                        <div class="icon i-success" aria-hidden="true"><mat-icon>add_circle</mat-icon></div>
                        <h3>Create Cycle</h3>
                        <p>Start a new business cycle with defined timelines and objectives.</p>
                    </div>
                    <div class="cta">Create new cycle →</div>
                </a>
            }

            @if (canViewCycles) {
                <a routerLink="/view-cycles" class="card" role="button" aria-label="View cycles">
                    <div>
                        <div class="icon i-success" aria-hidden="true"><mat-icon>list_alt</mat-icon></div>
                        <h3>View Cycles</h3>
                        <p>View and Review Cycles</p>
                    </div>
                    <div class="cta">View Cycles →</div>
                </a>
            }

            @if (canManageForms) {
                <a routerLink="/manage-form" class="card" role="button" aria-label="Manage form">
                    <div>
                        <div class="icon i-brand" aria-hidden="true"><mat-icon>description</mat-icon></div>
                        <h3>Manage Form </h3>
                        <p>Create, edit, and configure form templates and manage form submissions.</p>
                    </div>
                    <div class="cta">Manage forms →</div>
                </a>
            }

            @if (canManageUsers) {
                <a routerLink="/user-management" class="card" role="button" aria-label="Manage users">
                    <div>
                        <div class="icon i-brand" aria-hidden="true"><mat-icon>group</mat-icon></div>
                        <h3>Manage User</h3>
                        <p>Create, update, deactivate users and reset credentials.</p>
                    </div>
                    <div class="cta">Open users →</div>
                </a>
            }

            @if (canManageMasterData) {
                <a routerLink="/master-data" class="card" role="button" aria-label="Master data">
                    <div>
                        <div class="icon i-neutral" aria-hidden="true"><mat-icon>storage</mat-icon></div>
                        <h3>Master Data</h3>
                        <p>Manage Master Data. View and update relevant Data</p>
                    </div>
                    <div class="cta">Open Master data →</div>
                </a>
            }

            @if (canViewComplianceRecords) {
                <a routerLink="/compliance-records" class="card" role="button" aria-label="Compliance Records">
                    <div>
                        <div class="icon i-brand" aria-hidden="true"><mat-icon>list_alt</mat-icon></div>
                        <h3>Compliance Records</h3>
                        <p>View Compliance Data with Answers with "NO"</p>
                    </div>
                    <div class="cta">Open Compliance Records →</div>
                </a>
            }

        </div>
    </div>

    <aside class="side" aria-label="Overview">
        <div>
            <div class="section-title"><mat-icon class="section-icon">task_alt</mat-icon>What you can do</div>
            <ul class="capability-list">
                @if (userRoleCode !== 'BUADMIN') {
                    <li>Configure your market, run cycles, and manage forms</li>
                }
                <li>Create cycles, review and monitor cycles</li>
                <li>Update Master Data and manage users for your Market</li>
            </ul>
        </div>

        <div>
            <div class="section-title"><mat-icon class="section-icon">link</mat-icon>Quick links</div>
            <div class="list">
                @if (reportsDashboardUrl) {
                  <a class="list-item" target="_blank" rel="noopener noreferrer" [href]="reportsDashboardUrl">
                      <div class="icon icon-small i-brand" aria-hidden="true"><mat-icon>analytics</mat-icon></div>
                      <div>
                          <p class="title">Reports and Dashboard</p>
                          <p class="sub">View analytics, metrics, and performance reports</p>
                      </div>
                  </a>
                }
            </div>
        </div>

        <div>
            <div class="section-title"><mat-icon class="section-icon">person</mat-icon>Need Help?</div>
            <div class="list">
                <a routerLink="/help-guide" class="list-item">
                    <div class="icon icon-small i-neutral" aria-hidden="true"><mat-icon>help_outline</mat-icon></div>
                    <div>
                        <p class="title">Help Guide</p>
                        <p class="sub">Access documentation, tutorials, and FAQs</p>
                    </div>
                </a>

                <a routerLink="/contact-support" class="list-item">
                    <div class="icon icon-small i-brand" aria-hidden="true"><mat-icon>support_agent</mat-icon></div>
                    <div>
                        <p class="title">Contact & Support</p>
                        <p class="sub">Get in touch with our support team</p>
                    </div>
                </a>
            </div>
        </div>
    </aside>
</section>


